import React from 'react'
import { LucideIcon, Plus } from 'lucide-react'

interface EmptyStateAction {
  label: string
  icon?: LucideIcon
  onClick: () => void
}

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: EmptyStateAction
  secondaryAction?: EmptyStateAction
}

const ContactEmptyState = ({ icon: Icon, title, description, action, secondaryAction }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <span className="p-3 rounded-xl bg-primary-variant mb-4">
        <Icon className="w-5 h-5 text-color-accent" />
      </span>
      <h3 className="text-base font-semibold text-neutral">{title}</h3>
      <p className="text-sm text-neutral-faded mt-1 max-w-xs">{description}</p>

      {(action || secondaryAction) && (
        <div className="flex items-center gap-3 mt-4">
          {action && (
            <button
              onClick={action.onClick}
              className="flex items-center gap-2 py-2 px-4 rounded-lg bg-gradient-to-r from-[#8B5CF6] to-[#3B82F6] text-white text-sm font-medium hover:opacity-90 transition-opacity"
            >
              {action.icon ? <action.icon className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
              {action.label}
            </button>
          )}
          {secondaryAction && (
            <button
              onClick={secondaryAction.onClick}
              className="flex items-center gap-2 py-2 px-4 rounded-lg border border-neutral-medium/40 text-neutral text-sm font-medium hover:bg-white/5 transition-colors"
            >
              {secondaryAction.icon && <secondaryAction.icon className="w-4 h-4" />}
              {secondaryAction.label}
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default ContactEmptyState